import { render, staticRenderFns } from "./card-c.vue?vue&type=template&id=6252eb2a&scoped=true&lang=pug&"
import script from "./card-c.vue?vue&type=script&lang=js&"
export * from "./card-c.vue?vue&type=script&lang=js&"
import style0 from "./card-c.vue?vue&type=style&index=0&id=6252eb2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6252eb2a",
  null
  
)

export default component.exports